import type { BoraConfig, BoraTheme, Locale } from '@/root/shared-types'

export const i18nConfig: BoraConfig = {
  tuuleliinid: {
    locales: ['en', 'et'],
    defaultLocale: 'et',
  },
  kihnu: {
    locales: ['et', 'en'],
    defaultLocale: 'et',
  },
  sark: {
    locales: ['en'],
    defaultLocale: 'en',
  },
  trial: {
    locales: ['en'],
    defaultLocale: 'en',
  },
}

const getTheme = (theme?: BoraTheme): BoraTheme => (theme ?? process.env.NEXT_PUBLIC_THEME) as BoraTheme

export const getI18nConfig = (theme?: BoraTheme) => i18nConfig[getTheme(theme)]

export const getDefaultLocale = (theme?: BoraTheme): Locale => getI18nConfig(theme).defaultLocale

export const resolveLocale = (locale: string | null | undefined, theme?: BoraTheme): Locale => {
  const { locales, defaultLocale } = getI18nConfig(theme)
  const normalizedLocale = locale?.split(',')[0]?.trim().split('-')[0] as Locale | undefined

  return normalizedLocale && locales.includes(normalizedLocale) ? normalizedLocale : defaultLocale
}
